import { Dictionary } from "@insite/client-framework/Common/Types";
import { Reducer, ReducersMapObject, UnknownAction } from "redux";

const getExtensionPropsFromCombinedReducer = <S extends Dictionary<any>, A extends UnknownAction, P = S>(
    combinedReducer: Reducer<S, A, P>,
): ReducersMapObject<S, A> => {
    const result = {} as { [K in keyof S]: Reducer<S[K], A> };

    // Call the combined reducer with dummy values to get the default state.
    const baseState = combinedReducer({} as S, { type: ":NONE:" } as A);

    // Create a dictionary of empty reducers based on the state properties.
    Object.keys(baseState).forEach((key: keyof S) => {
        result[key] = state => state || ({} as S[keyof S]);
    });

    return result;
};

export default getExtensionPropsFromCombinedReducer;
